import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { MessagesEnum } from 'src/app/domain/enums/messages.enum';
import {
  SystemActionCategoryTypeIdEnum,
  getSystemActionCategoryTypeDescriptionByValue,
} from 'src/app/domain/registration/enums/system-action-category-type.enum';
import { IUserGroup } from 'src/app/domain/registration/models/IUserGroup';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { UserGroupService } from '../crud-service';

@Component({
  selector: 'app-user-group-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class UserGroupCESComponent
  extends AbstractCrudCES<IUserGroup>
  implements OnInit, OnDestroy
{
  public back() {
    this.router.navigate(['user-groups']);
  }

  override config: IFieldConfig[] = CES_CONFIG_FIELDS;
  public filteredCities: any[] = [];

  setFields() {
    this.form.patchValue({
      ...this.data,
    });
  }

  getCreatedAt() {
    return this.data?.createdAt;
  }

  getUpdatedAt() {
    return this.data?.updatedAt;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private service: UserGroupService,
    public override fb: FormBuilder,
    private dialog: MatDialog,
    private toastService: ToastService,
    private location: Location
  ) {
    super(fb);
    this.typeCes = route.snapshot.data['type'];
    this.title = `${this.typeCes} ${this.service.title.toUpperCase()}`;
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  ngAfterViewInit(): void {
    this.route.params.subscribe((params) => {
      if (params['id'])
        this.service.get(params['id']).subscribe((data: any) => {
          this.data = data;
          this.setFields();
        });
    });
  }

  ngOnDestroy() {}

  public async save() {
    if (this.form.valid) {
      if (this.form.get('id')?.value) {
        this.service
          .update(this.form.get('id')?.getRawValue(), {
            ...this.form.value,
            name: this.form.get('name')?.value?.toUpperCase(),
          })
          .subscribe((data: any) => {
            this.router.navigate(['user-groups/show', this.data.id]);
            this.toastService.showSuccess(MessagesEnum.SUCCESS_UPDATED);
          });
      } else {
        this.service
          .create({
            name: this.form.get('name')?.value?.toUpperCase(),
            description: this.form.get('description')?.value?.toUpperCase(),
          })
          .subscribe((data: any) => {
            this.router.navigate(['user-groups/show', data.id]);
            this.toastService.showSuccess(MessagesEnum.SUCCESS_CREATED);
          });
      }
    }
  }

  public edit() {
    this.router.navigate(['user-groups/edit', this.data.id]);
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }
}
